<template>
    <div class="content">
        <template v-if="!isSuccess">
            <div class="form">
                <fieldset class="fieldset">
                    <div class="item">
                        <div :class="[{ 'input-validation-error': isValidationError('IsIndipendentHouse') }, 'checkbox']">
                            <input type="checkbox" id="IsIndipendentHouse" v-model="formData.isIndipendentHouse" />
                            <label for="IsIndipendentHouse">Conferma che la tua abitazione è indipendente</label>
                        </div>
                    </div>
                    <div class="item" data-label="top">
                        <label class="label" for="Name">Nome</label>
                        <input type="text" name="Name" id="Name" aria-label="Nome" v-model.lazy="formData.name" :class="[{ 'input-validation-error': isValidationError('Name') }, 'textbox']" />
                    </div>
                    <div class="item" data-label="top">
                        <label class="label" for="Surname">Cognome</label>
                        <input type="text" name="Surname" id="Surname" aria-label="Cognome" v-model.lazy="formData.surname" :class="[{ 'input-validation-error': isValidationError('Surname') }, 'textbox']" />
                    </div>
                    <div class="item" data-label="top">
                        <label class="label" for="Phone">Telefono</label>
                        <input type="text" name="Phone" id="Phone" aria-label="Telefono" v-model.lazy="formData.phone" :class="[{ 'input-validation-error': isValidationError('Phone') }, 'textbox']" />
                    </div>
                    <div class="item" data-label="top">
                        <label class="label" for="Email">Email</label>
                        <input type="text" name="Email" id="Email"  aria-label="Email" v-model.lazy="formData.email" :class="[{ 'input-validation-error': isValidationError('Email') }, 'textbox']" />
                    </div>
                    <div class="item" data-label="top">
                        <label class="label" for="City">Città</label>
                        <input type="text" name="City" id="City" aria-label="Città" v-model.lazy="formData.city" :class="[{ 'input-validation-error': isValidationError('City') }, 'textbox']" />
                    </div>
                    <div class="item" data-label="top">
                        <label class="label" for="Zone">Provincia</label>
                        <select id="Zone" aria-label="Provincia" v-model.lazy="formData.zone" :class="[{ 'input-validation-error': isValidationError('Zone') }, 'dropdown']">
                            <option :value="null">...</option>
                            <option v-for="(zone, index) in provinces" :value="zone.value" :key="index">
                                {{ zone.title }}
                            </option>
                        </select>
                    </div>
                    <div class="item">
                        <div :class="[{ 'input-validation-error': isValidationError('IsPrivacyPolicy') }, 'checkbox']">
                            <input type="checkbox" id="IsPrivacyPolicy" v-model="formData.IsPrivacyPolicy" />
                            <label for="IsPrivacyPolicy"><span class="disclaimer" @click="showPrivacyPolicy()">Confermo di aver letto la <a :href="routes.UrlPolicyInfoRequest" rel="noreferrer" target="_blank" class="button-privacy" aria-label="Beghelli.it - Privacy policy">Privacy Policy</a></span></label>
                        </div>
                    </div>
                    <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                        <ul>
                            <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                        </ul>
                    </div>
                    <div class="item">
                        <div class="calltoaction full">
                            <button id="ButtonSubmit" class="button full" @click="submitForm()">Invia</button>
                        </div>
                    </div>
                    <div class="item">
                        <div class="grecaptcha-terms">Questo sito è protetto da reCAPTCHA e si applicano la <a href="https://policies.google.com/privacy" target="_blank" aria-label="Google privacy" rel="noopener">Normativa sulla privacy</a> e i <a href="https://policies.google.com/terms" target="_blank" aria-label="Google terms" rel="noopener">Termini di servizio</a> di Google.</div>
                    </div>
                </fieldset>
            </div>
        </template>
        <div class="success" v-else>
            <div class="content">
                <div class="maintitle s35"><img src="/areas/soledicasa/images/check.svg" width="21" height="18" alt="Check" class="check">Richiesta inviata!</div>
            </div>
            <div class="maintitle s24 upper">
                Sarai ricontattato al più presto
                <div class="underline"></div>
            </div>
            <div class="download">
                <div class="maintitle s22 white">
                Leggi il nostro kit informativo
                </div>
                <div class="calltoaction">
                <a href="/media/soledicasa/Beghelli Sole di Casa - Kit Informativo.pdf" class="button">Scarica subito!</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import FormHelper from "@Scripts/Common/FormHelper";

const props = defineProps<{
    recaptchaSiteKey: string;
    originPage: string;
}>();

const routes = (window as any).App.routes;

const isLoading = ref<boolean>(false);
const isSuccess = ref<boolean>(false);
const isPrivacyPolicyShow = ref<boolean>(false);
const privacyPolicy = ref<string | null>(null);
const formData = ref<any>({ zone: null });
const validationErrors = ref<any[]>([]);
const provinces = ref<any[]>([]);

onBeforeMount(async () => {
    const result = (await axios.post(routes.SoleDiCasa_GetInfoRequestData, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    privacyPolicy.value = Object.freeze(result.privacyPolicy);
    provinces.value = result.provinces;
});

async function showPrivacyPolicy() {
    isPrivacyPolicyShow.value = !isPrivacyPolicyShow.value;
}

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoading.value = true;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: "Submit" });
        try {
            await axios.post(routes.SoleDiCasa_InfoRequestSubmit, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken(), "RecaptchaVerificationToken": token } });

            isSuccess.value = true;

            GTagHelper.sendEvent("form_submit", "soledicasa_info_request");
            (window as any).gtag("event", "conversion", { "send_to": "AW-412883659/fCJGCO62-J0ZEMu18MQB" });
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }
    });

    isLoading.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>